/** CMS MBI format, mirrored in backend mbi.util.ts. Normalize separators/case, never guess characters.
 * https://bluebutton.cms.gov/data-dictionary/bene-mbi-id/ */
export const MBI_LENGTH = 11;

const MBI_PATTERN = /^[1-9][AC-HJKMNP-RT-Y][0-9AC-HJKMNP-RT-Y][0-9][AC-HJKMNP-RT-Y][0-9AC-HJKMNP-RT-Y][0-9][AC-HJKMNP-RT-Y]{2}[0-9]{2}$/;

/** MBIs are case-insensitive and often typed or printed with spaces or dashes. */
export function normalizeMbi(raw) {
  if (!raw) return '';
  return String(raw).replace(/[\s-]/g, '').toUpperCase();
}

export function isValidMbi(raw) {
  return MBI_PATTERN.test(normalizeMbi(raw));
}
